import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';
import 'react-popper-tooltip/dist/styles.css';
import { useUpdateNotesMutation } from '../../../../../features/contactsApi';
import { addBannerWithTimeout } from '../../../../lib/centralizedBanner/slice';
import { ContactType } from "../../../../lib/filters/dto";
import { keycloak } from '../../../../lib/keycloak';
import { useAppDispatch } from '../../../../lib/redux/hooks';
import Input from '../../../../ui/molecules/input';
import { NoteDTO } from '../../dto';

interface Props {
    contactId: string;
    contactType: ContactType
    width: number;
    lastNote: string;
    notes: NoteDTO[] | null;
    targetListId?: string;
}
export function CreateNoteTooltip({ contactId, width, lastNote, notes, contactType }: Props) {
    const [text, setText] = useState('');
    const dispatch = useAppDispatch();

    const [updateNotes, { isLoading, reset }] = useUpdateNotesMutation();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        return () => {
            reset();
        };
    }, [reset]);

    const handleUpdateNote = async (newNotes: NoteDTO[]) => {
        try {
            await updateNotes({ contactId, notes: newNotes, contactType }).unwrap();
            setText('')
            setVisible(false);
            dispatch(addBannerWithTimeout({
                message: "Nota aggiunta con successo",
                variant: "success"
            }));
        } catch (error: any) {
            dispatch(addBannerWithTimeout({
                message: "Si è verificato un errore durante l'aggiunta della nota",
                variant: "error"
            }));
        }
    };

    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                containerRef.current &&
                !containerRef.current.contains(event.target as Node)
            ) {
                setVisible(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        if (!visible && text.trim() && !(keycloak.hasRealmRole('customer') || keycloak.hasRealmRole('collaborator'))) {
            const newNotes = [...notes ?? []]
            newNotes.push({
                note: text.trim(),
                authorUserId: keycloak.subject!,
                date: new Date().toISOString().replace('Z', '+00:00')
            })
            handleUpdateNote(newNotes)
        } else if (visible) {
            setText('');
        }
    }, [visible])

    const handleDoubleClick = () => {
        if (!(keycloak.hasRealmRole('customer') || keycloak.hasRealmRole('collaborator'))) {
            setVisible((prev) => !prev);
        }
    };

    return (
        <div
            onDoubleClick={handleDoubleClick}
            className={clsx("flex cursor-pointer")}
            style={{ width: `${width}px` }}
            ref={containerRef}
        >
            <div className='w-full'>
                {
                    visible ?
                        <Input
                            autofocus
                            placeholder='Aggiungi una nota...'
                            value={text}
                            onChangeText={t => setText(t)}
                            onKeyDown={e => {
                                if (e.key === 'Enter') {
                                    if (text.trim() && !(keycloak.hasRealmRole('customer') || keycloak.hasRealmRole('collaborator'))) {
                                        const newNotes = [...notes ?? []]
                                        newNotes.push({
                                            note: text.trim(),
                                            authorUserId: keycloak.subject!,
                                            date: new Date().toISOString().replace('Z', '+00:00')
                                        })
                                        handleUpdateNote(newNotes)
                                    } else {
                                        setVisible(false);
                                    }
                                }
                            }}

                        />
                        :
                        <div className="input-container truncate border-neutral-300 input-value">
                            {lastNote || "NUOVA NOTA"}
                        </div>
                }
            </div>
        </div>
    );
}
